module.exports = __webpack_public_path__ + "static/media/c1.b19153c5.jpg";